import { LocalDictionaryFactory } from  '../../api/api.module'

import { LoggerService } from  '../../common/common.module'

import { IUserSession } from '../../../helpers/user-session'

import { AlarmDirectiveController } from './alarms-details.directive.controller'

import { AlarmHelper } from '../alarms.helper'

//#region Asset Imports

import './alarms-details.scss'
import * as TEMPLATE from './alarms-details.tpl.html'

//#endregion

// Setup

export class AlarmDetailsDirective implements ng.IDirective {
    
    restrict = 'E'

    scope = {
        id: '='
    }

    controller = ['$scope', '$q', '$timeout', 'logger', 'localDictionary', 'userSession',(
        $scope: any, 
        $q: ng.IQService, 
        $timeout: ng.ITimeoutService, 
        logger: LoggerService, 
        localDictionary: LocalDictionaryFactory, 
        userSession: IUserSession
    ) => new AlarmDirectiveController(
        $scope, 
        $q, 
        $timeout,
        logger, 
        localDictionary, 
        userSession, 
        AlarmHelper.REFERENCE_TYPE,
        AlarmHelper.SIMAX_MODULE_NAME
    )]

    template = TEMPLATE
}

// Setup End